import {MatrixClient} from 'matrix-js-sdk';
import {getCurrentRoom, getMetadata} from '.';
import {DocumentType} from '@/types/common';

export const isDirectChat = async (client: MatrixClient, roomId: string) => {
  const room = await getCurrentRoom(client, roomId);
  if (room) {
    const metadata = await getMetadata(room);
    if (metadata) {
      const {documentType} = metadata;
      if (documentType === DocumentType.P2P) {
        return true;
      }
      return false;
    }
    return false;
  }
  return false;
};
